import { render, staticRenderFns } from "./rankGame.vue?vue&type=template&id=77aad1fe&scoped=true"
import script from "./rankGame.vue?vue&type=script&lang=js"
export * from "./rankGame.vue?vue&type=script&lang=js"
import style0 from "./rankGame.vue?vue&type=style&index=0&id=77aad1fe&prod&lang=css"
import style1 from "./rankGame.vue?vue&type=style&index=1&id=77aad1fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aad1fe",
  null
  
)

export default component.exports